<div class="container">
  <div class="discover-us-container">
    <div class="discover-us-content">
      <div class="people-trust-us">
        <p i18n>People Trust us ❤️</p>
      </div>
      <h1 i18n>Taste the Authenticity of Home</h1>
      <p i18n>
        Discover and order from the finest home chefs in your neighborhood
      </p>
      <custom-search-bar class="ms-2"></custom-search-bar>
      <p class="categories-text" i18n>Categories</p>
      <div class="categories">
        <div *ngFor="let category of categories" class="category-item-container"
             (click)="filterBy(category)">
          <p>{{ category.name }}</p>
        </div>
        <div class="category-item-container" (click)="filterBy(allCategory)">
          <img src="assets/category-icon.svg" alt="Chicken">
          <p i18n>Explore all</p>
        </div>
      </div>
    </div>
    <div class="discover-us-img-container">
      <div class="hero-section-img-background">
        <img src="assets/discover-us-background.png">
      </div>
      <img src="assets/discover-us.png">
    </div>
  </div>
  <div class="next-arrow-div">
    <img src="assets/next-section-arrow.svg">
  </div>
</div>
